<template>
  <div class="credit-card-input">
    <v-text-field label="Cardholder Name"
                  v-model="creditCard.name"
                  prepend-icon="mdi-account"
                  :rules="requiredRules"/>
    <v-text-field label="Credit Card Number"
                  v-model="creditCard.number"
                  prepend-icon="mdi-credit-card"
                  :mask="creditCardMask"
                  :rules="creditCardRules"/>
    <v-text-field label="Expiration Date"
                  v-model="creditCard.expiration"
                  prepend-icon="mdi-calendar"
                  mask="##/##"
                  return-masked-value
                  :rules="requiredRules"/>
    <v-text-field label="Security Code"
                  v-model="creditCard.cvv"
                  prepend-icon="mdi-lock"
                  mask="####"
                  :rules="securityCodeRules"/>
  </div>
</template>

<script>
export default {
  props: {
    creditCard: Object
  },

  data () {
    return {
      requiredRules: [
        v => !!v || 'Cannot be blank'
      ],
      creditCardRules: [
        v => !!v || 'Cannot be blank',
        v => v.length >= 15 || 'Invalid credit card number'
      ],
      securityCodeRules: [
        v => !!v || 'Cannot be blank',
        v => v.length >= 3 || 'Invalid security code'
      ]
    }
  },

  computed: {
    creditCardMask () {
      if (this.creditCard.brand === 'AMEX') {
        return '####-######-#####'
      }
      return '####-####-####-####'
    }
  }
}

</script>



// WEBPACK FOOTER //
// credit-card-input.vue?dc68395c